<template>
  <div class="compat flex">
    <div class="label flex1 fs17">选择常用{{ isTeam ? '咨询人' : '就诊人' }}</div>
    <div class="text flex0 flex">
      <span
        class="flex0 fs15 color_main">{{ currentCompat.compatName }} {{
          currentCompat.compatGender|getGender
        }} {{ currentCompat.compatAge }}</span>
      <v-icon-arrow-right v-if="showArrowRight" class="color_999 fs12"/>
    </div>

    <div class="">
      <div v-if="showTag" @click='hide' class="mask fixed"></div>
      <transition name="fade">
        <div v-if="showTag" class="main fixed">
          <ol>
            <li v-for="(o,i) in list" class="fs16 center">{{ o.compatName }}</li>
          </ol>
          <ol>
            <router-link tag="li" :to="{path:'/addUsualPatient',query:{callback:$route.fullPath}}" class="fs16 center">
              添加就诊人
            </router-link>
            <li @click="hide" class="fs16 center">取消</li>
          </ol>
        </div>
      </transition>
    </div>


  </div>
</template>

<style scoped lang="scss">
@import "../../common/public";

.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  transform: translateY(100%);
}

ol {
  background-color: white;

  li {
    line-height: 50px;
  }
}

li + li {
  @include border(top);
}

ol + ol {
  margin-top: 10px;
}

.mask {
  @include t_r_b_l();
  background-color: rgba(0, 0, 0, .5);
  z-index: 10000;
}

.main {
  @include t_r_b_l(1);
  background-color: #f8f8f8;
  z-index: 11000;
}

.compat {
  .text {
    align-items: center;

    span, img {
      display: block;
    }

    span {
      margin-right: 5px;
    }
  }
}
</style>

<script>
import api from "../../lib/api"
import weuijs from "weui.js"
import {getGender} from "../../lib/filter";
import VIconArrowRight from "@/plugins/v-icon-arrow-right";
import {userService} from "@/services/user";

export default {
  name: 'commpat-choose',
  props: {
    isTeam: {//是否团队咨询
      type: Boolean,
      default: false
    },
    current: {
      type: Number,
      default: 0
    },
    showArrowRight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showTag: false,
      list: [],
    };
  },
  computed: {
    isRenewal() {
      return this.$route.query.type === 'renewal'
    },
    currentCompat() {
      let compat = this.list[this.current];
      this.$emit("compat", compat)
      return compat || {};
    }
  },
  filters: {getGender},
  components: {VIconArrowRight},
  created() {
    this.getList();
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    check(index) {
      this.current = index;
      this.hide();
    },
    hide() {
      this.showTag = false;
    },

    change() {
      if (!this.isRenewal)
        this.showTag = true;
    },

    async getList() {
      this.list = await userService.compatList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/plugins/user/compat.vue